import { forwardRef } from "react";
import "./index.scss";

export const Input = forwardRef(
  (
    {
      id = "",
      name = "",
      type = "text",
      placeholder = "",
      customClassName = "",
      ...props
    },
    ref
  ) => (
    <input
      id={id}
      name={name}
      type={type}
      placeholder={placeholder}
      className={`input ${customClassName}`}
      data-testid={id}
      ref={ref}
      {...props}
    />
  )
);
